export function getExpInYrs() {
  const today = new Date();
  const inputDate = new Date("2018-07-12");
  const timeDiff = today - inputDate;
  const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
  const yearsDiff = timeDiff / millisecondsInYear;
  return Math.floor(Math.abs(yearsDiff));
}
